// eslint-disable-next-line import/prefer-default-export
export const muiCardContentComponent = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing('NONE'),
    }),
  },
};
